export const actionTypes = {
  REQUEST_START: 'TAPS.REGIONS.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.REGIONS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.REGIONS.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
